import type { JsonValue } from "./json";
import type { RequestDetails, Task, TaskResult } from "./tasks";

export type RequestHistoryTargets = Readonly<{ requestIds: readonly string[]; taskIds: readonly string[] }>;

export const REQUEST_HISTORY_MODALITIES = ["image", "video", "audio", "language"] as const;
export const REQUEST_HISTORY_KINDS = ["task", "api"] as const;
export const REQUEST_HISTORY_DISPLAY_STATUSES = ["succeeded", "failed", "delivery_failed", "running"] as const;
export const REQUEST_HISTORY_QUERY_MAX_LENGTH = 256;
export type RequestHistoryFilters = Readonly<{
  query?: string;
  modality?: typeof REQUEST_HISTORY_MODALITIES[number];
  kind?: typeof REQUEST_HISTORY_KINDS[number];
  displayStatus?: typeof REQUEST_HISTORY_DISPLAY_STATUSES[number];
}>;

export const REQUEST_HISTORY_SNAPSHOT_LIMITS = { frameBytes: 512_000, snapshotBytes: 4_194_304, chunkChars: 48_000, maxChunks: 100 } as const;
export type RequestHistorySnapshotChunk = Readonly<{ id: string; index: number; total: number; chunk: string }>;

export type RequestHistorySnapshot = Readonly<{
  version: 1;
  accountId: string;
  requestDetailsComplete?: boolean;
  requests: readonly RequestDetails[];
  tasks: readonly Task<JsonValue>[];
  removedRequestIds: readonly string[];
  removedTaskIds: readonly string[];
  newRequestIds: readonly string[];
  newTaskIds: readonly string[];
  requestPage?: Readonly<{ ids: readonly string[]; nextCursor?: string }>;
  taskPage?: Readonly<{ ids: readonly string[]; nextCursor?: string }>;
}>;

export function taskWithRequestDetails(task: TaskResult, request?: RequestDetails): Task<JsonValue> {
  const legacy = task as Partial<Task>;
  return { ...task, assets: task.assets ?? [],
    createdAt: request?.createdAt ?? legacy.createdAt ?? request?.receivedAt ?? "",
    updatedAt: request?.updatedAt ?? legacy.updatedAt ?? request?.finishedAt ?? request?.receivedAt ?? "",
    operation: request?.operation ?? legacy.operation ?? "", schemaVersion: request?.schemaVersion ?? legacy.schemaVersion ?? 0,
    runId: request?.runId ?? legacy.runId, startedAt: request?.startedAt ?? legacy.startedAt, completedAt: request?.completedAt ?? legacy.completedAt,
    ...(request ? { input: request.input ?? undefined, metadata: request.metadata, timing: request.timing, cost: request.cost, billingStatus: request.billingStatus, billingReason: request.billingReason } : {}) };
}
